import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Protected from "../components/Protected";
import ToiPageHeader from "../components/toi/ToiPageHeader";
import { REMITTANCE_SIGNUP } from "../config/constants";
import { REMITTANCE_HOME_PATH, REMITTANCE_NB_HOME_PATH } from "../constants";
import FullScreenSkeleton from "../components/Skeletons/FullScreenSkeleton";
import GetAppLanding from "../pages/GetAppLanding/GetAppLanding";
import TOILandingExperiment from "../pages/toi/landing/TOILandingExperiment";

// Lazy loaded pages (default exports)
// const Signup = lazy(() => import("../pages/SignUp"));
// const Login = lazy(() => import("../pages/Login"));
const Resetpassword = lazy(() => import("../pages/ResetPassword"));
// const Rewards = lazy(() => import("../pages/accounts/rewards/Rewards"));
// const GetAppLanding = lazy(
//   () => import("../pages/GetAppLanding/GetAppLanding"),
// );
const Plaid = lazy(() => import("../pages/Plaid"));
const ManageAccounts = lazy(() => import("../pages/ManageAccounts"));
const UserForm = lazy(() => import("../pages/UserForm"));
const Withdrawal = lazy(() => import("../pages/Withdrawal"));
const SignupV2 = lazy(() => import("../pages/SignupV2"));
const WillowSignup = lazy(() => import("../pages/WillowSignup"));
const WillowSignupSuccess = lazy(() => import("../pages/WillowSignupSuccess"));
const VerifyOtp = lazy(() => import("../pages/toi/VerifyOtp"));
// const TOILandingPage = lazy(() => import("../pages/toi/TOILandingPage"));
const TOILandingPageA = lazy(
  () => import("../pages/toi/landing/TOILandingPageA"),
);
const TOILandingPageB = lazy(
  () => import("../pages/toi/landing/TOILandingPageB"),
);
const TOILandingPageC = lazy(
  () => import("../pages/toi/landing/TOILandingPageC"),
);
const TOIUpdatedLandingPage = lazy(
  () => import("../pages/toi/landing/TOIUpdatedLandingPage"),
);
const TOIPartnershipLandingPage = lazy(
  () => import("../pages/toi/landing/TOIPartnershipLandingPage"),
);
const RecipientBankDetailsPage = lazy(
  () => import("../pages/toi/RecipientBankDetailsPage"),
);
const TOIAppSignUp = lazy(() => import("../pages/toi/toiAppSignUp"));
const VerifyDetails = lazy(() => import("../pages/VerifyDetails"));
const RemittanceCalcuator = lazy(
  () => import("../pages/Remittance/RemittanceCalculator"),
);
const Reauthenticate = lazy(() => import("../pages/Remittance/Reauthenticate"));
const RemittanceDashboard = lazy(
  () => import("../pages/Remittance/RemittanceDashboard"),
);
const RemittanceRateHome = lazy(
  () => import("../pages/Remittance/RemittanceRateHome"),
);
const CrosswalkSignup = lazy(() => import("../pages/cricbuzz/CrosswalkSignup"));
// const Insomania = lazy(() => import("../pages/cricbuzz/insomania/Insomania"));
// Named export -> map to default for React.lazy
const TOIThemeProvider = lazy(() =>
  import("../pages/toi/TOIThemeProvider").then((module) => ({
    default: module.TOIThemeProvider,
  })),
);
const TOIEmailUpdate = lazy(() => import("../pages/toi/toiEmailUpdate"));
const TOIKycPage = lazy(() => import("../pages/toi/toiKycPage"));

const withSuspense = (element) => (
  <Suspense fallback={<FullScreenSkeleton />}>{element}</Suspense>
);

const TOIOnboardingHeader = ({ children }) => {
  const isTOIChannel =
    typeof window !== "undefined" &&
    (window.sessionStorage.getItem("channel") || "") === "TOI";
  const theme =
    (typeof window !== "undefined" && window.sessionStorage.getItem("theme")) ||
    "light";

  return (
    <>
      {isTOIChannel ? (
        <ToiPageHeader
          showBackButton={false}
          theme={theme}
        />
      ) : null}
      {children}
    </>
  );
};
const getBasename = () => {
  if (typeof window === "undefined") return "/getapp";

  const host = window.location.hostname;

  if (host === "joinabound.com" || host === "www.joinabound.com" || host === "getapp.timesclub.co" ) {
    return "/";
  }

  return "/getapp";
};

function RouteController() {
  return (
    <Router basename={getBasename()}>
      <Routes>
        <Route index element={<GetAppLanding />} />
        <Route path="/getApp" element={<GetAppLanding />} />
        {/* <Route path="/" element={<Navigate to="/login" />} /> */}
        <Route
          path="/signup"
          element={withSuspense(
            <TOIOnboardingHeader>
              <TOIThemeProvider>
                <TOIAppSignUp />
              </TOIThemeProvider>
            </TOIOnboardingHeader>,
          )}
        />
        <Route
          path="/signup/v2"
          element={withSuspense(
            <TOIThemeProvider>
              <SignupV2 />
            </TOIThemeProvider>,
          )}
        />
        <Route
          path="/login"
          element={withSuspense(
            <TOIOnboardingHeader>
              <TOIThemeProvider>
                <TOIAppSignUp />
              </TOIThemeProvider>
            </TOIOnboardingHeader>,
          )}
        />
        <Route
          path="/resetPassword"
          element={withSuspense(<Resetpassword />)}
        />
        <Route path="/user-form" element={withSuspense(<UserForm />)} />
        <Route path="/withdrawal" element={withSuspense(<Withdrawal />)} />
        <Route
          path="/plaid"
          element={withSuspense(
            <Protected>
              <Plaid />
            </Protected>,
          )}
        />
        <Route
          path="/verifyDetails"
          element={withSuspense(
            <TOIOnboardingHeader>
              <VerifyDetails />
            </TOIOnboardingHeader>,
          )}
        />
        <Route
          path="/accounts"
          element={withSuspense(
            <Protected>
              <ManageAccounts />
            </Protected>,
          )}
        />
        <Route
          path="/remittance/calculator"
          element={withSuspense(<RemittanceCalcuator />)}
        />
        {/* <Route
          path="/rewards"
          element={
            <Protected>
              <Rewards />
            </Protected>
          }
        ></Route> */}
        <Route
          path="/willow/forget-password"
          element={withSuspense(<WillowSignup />)}
        />
        <Route
          path="/willow/success"
          element={withSuspense(<WillowSignupSuccess />)}
        />
        <Route
          path="/crosswalk/signup"
          element={withSuspense(<CrosswalkSignup />)}
        />
        {/* <Route path="/crosswalk/signup" element={<Insomania />} />
          <Route path="/remittance/toi" element={<Insomania />} /> */}

        <Route
          path="/remittance/signup"
          element={withSuspense(<SignupV2 screenType={REMITTANCE_SIGNUP} />)}
        />

        <Route path="/verify-otp" element={withSuspense(<VerifyOtp />)} />

        <Route
          path="/onboarding/landing"
          element={withSuspense(
            <TOIThemeProvider>
              <TOILandingExperiment />
            </TOIThemeProvider>,
          )}
        />
        <Route
          path="/onboarding/landing_a"
          element={withSuspense(
            <TOIThemeProvider>
              {/* <TOILandingPageA /> */}
              <TOIUpdatedLandingPage />
            </TOIThemeProvider>,
          )}
        />
        <Route
          path="/onboarding/landing_b"
          element={withSuspense(
            <TOIThemeProvider>
              {/* <TOILandingPageB /> */}
              <TOIPartnershipLandingPage />
            </TOIThemeProvider>,
          )}
        />
        <Route
          path="/onboarding/landing_c"
          element={withSuspense(
            <TOIThemeProvider>
              <TOILandingPageC />
            </TOIThemeProvider>,
          )}
        />
        <Route
          path="/onboarding/landing_updated"
          element={withSuspense(
            <TOIThemeProvider>
              <TOIUpdatedLandingPage />
            </TOIThemeProvider>,
          )}
        />
        <Route
          path="/onboarding/recipient-bank-details"
          element={withSuspense(
            <TOIThemeProvider>
              <RecipientBankDetailsPage />
            </TOIThemeProvider>,
          )}
        />
        <Route
          path="/onboarding/signup"
          element={withSuspense(
            <TOIOnboardingHeader>
              <TOIThemeProvider>
                <TOIAppSignUp />
              </TOIThemeProvider>
            </TOIOnboardingHeader>,
          )}
        />
        <Route
          path="/onboarding/email-update"
          element={withSuspense(
            <TOIOnboardingHeader>
              <TOIThemeProvider>
                <TOIEmailUpdate />
              </TOIThemeProvider>
            </TOIOnboardingHeader>,
          )}
        />
        <Route
          path="/onboarding/kyc"
          element={withSuspense(
            <TOIOnboardingHeader>
              <TOIThemeProvider>
                <TOIKycPage />
              </TOIThemeProvider>
            </TOIOnboardingHeader>,
          )}
        />
        <Route
          path="/remittance/bankadd"
          element={withSuspense(
            <Protected>
              <Plaid />
            </Protected>,
          )}
        />
        <Route
          path="/re-authenticate"
          element={withSuspense(
            <Protected>
              <TOIThemeProvider>
                <Reauthenticate />
              </TOIThemeProvider>
            </Protected>,
          )}
        />
        <Route
          path={REMITTANCE_NB_HOME_PATH}
          element={withSuspense(
            <Protected>
              <RemittanceDashboard />
            </Protected>,
          )}
        />
        <Route
          path={REMITTANCE_HOME_PATH}
          element={withSuspense(<RemittanceRateHome />)}
        />
      </Routes>
    </Router>
  );
}

export default RouteController;
